module.exports = __webpack_public_path__ + "media/images/pc/page_common/banner/banner_online_support-2808ef32a21a68772c1fa4acd1090974.jpg";